import React, {PropTypes} from 'react';

export default function ValidationError({error}) {
  return <li className="validation-error">{error}</li>;
}

ValidationError.propTypes = {
  error: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/ValidationError.js